import { Branch } from 'assets/models/Branch';

/**
 * Tiempo estimado que toma un servicio en completarse
 * El tiempo debe estar especificado en minutos como múltiplos de treinta hasta 480 (8 horas)
 */
export type EstimatedDurationValues = 30 | 60 | 90 | 120 | 150 | 180 | 210 | 240 | 300 | 360 | 420 | 480;
export class ServiceType {
	public _id: string;
	public name: string;
	public label: string;
	public type: string;
	/**
	 * Agrupa service types bajo una misma categoría.
	 * E.g. Los service types: Interruptor (switch), Main breaker y Receptáculos
	 * pertenecen a la categoría 'electricity'.
	 */
	public category?: string;
	public fields: Fields;
	public primary?: boolean;
	public isVial?: boolean;
	/**
	 * Tiempo estimado que toma un servicio en completarse
	 */
	public estimatedDuration?: EstimatedDurationValues;
	public schedulable?: boolean;
	public isTow?: boolean;
	public isInspection?: boolean;
	public branches?: Array<Branch>;
	/** Determina si un service type está deshabilitado. */
	public disabled?: boolean;
	/** The estimated duration of the service type when it is considered for automatic scheduling workflow */
	public routingEstimatedDuration?: EstimatedDurationValues;
	/** The sfIds of accounts that have that service type disabled */
	public disabledAccounts?: Array<string>;
}

export enum FieldNames {
	LOCALITY_TYPE = 'localityType',
	FIRSTNAME = 'firstname',
	LASTNAME = 'lastname',
	OTHERNAME = 'othername',
	PHONE_1 = 'phone1',
	PHONE_2 = 'phone2',
	SERVICE_COST = 'serviceCost',
	SITUATION = 'situation',
	DESTINATION = 'destination',
	VEHICLE = 'vehicle',
	PET = 'pet',
	SCHEDULE = 'schedule',
	TYPE_OF_PROPERTY = 'typeOfProperty',
	NUMBER_OF_ROOMS = 'numberOfRooms',
	TOW = 'tow',
	FLIGHT = 'flight',
	TAXI = 'taxi',
	INTERVENTORIA_STATUS = 'interventoriaStatus',
	ACOMETIDA_STATUS = 'acometidaStatus',
}
export interface Fields {
	[FieldNames.LOCALITY_TYPE]?: Field;
	[FieldNames.FIRSTNAME]: Field;
	[FieldNames.LASTNAME]: Field;
	[FieldNames.OTHERNAME]: Field;
	[FieldNames.PHONE_1]: Field;
	[FieldNames.PHONE_2]: Field;
	[FieldNames.SERVICE_COST]: Field;
	[FieldNames.SITUATION]: Field;
	[FieldNames.DESTINATION]: Field;
	[FieldNames.VEHICLE]: VehicleFields;
	[FieldNames.PET]: PetFields;
	[FieldNames.SCHEDULE]: Field;
	[FieldNames.TYPE_OF_PROPERTY]: Field;
	[FieldNames.NUMBER_OF_ROOMS]: Field;
	[FieldNames.TOW]: TowFields;
	[FieldNames.FLIGHT]: FlightFields;
	[FieldNames.TAXI]: TaxiFields;
}

export class VehicleFields {
	public year: Field;
	public make: Field;
	public model: Field;
	public color: Field;
	public vin: Field;
	public plate: Field;
	public category?: Field;
}
export interface FlightFields {
	direction: Field;
	airlineName: Field;
	number: Field;
	schedule: Field;
	ticketValidated: Field;
}

export interface TaxiFields {
	totalPassengers: Field;
	totalLuggage: Field;
}

export class PetFields {
	public name: Field;
	public age: Field;
	public breed: Field;
	public weight: Field;
	public vaccinationCard?: Field;
}

export class Field {
	public name: string;
	public label: string;
	public type: string;
	public visible: boolean;
	public required: boolean;
	public optional: boolean;
}

export class TowFields {
	public situationCondition: Field;
}

export type ServiceTypeFieldName =
	| FieldNames.FIRSTNAME
	| FieldNames.LASTNAME
	| FieldNames.OTHERNAME
	| FieldNames.PHONE_1
	| FieldNames.PHONE_2
	| FieldNames.SERVICE_COST
	| FieldNames.SITUATION
	| FieldNames.DESTINATION
	| FieldNames.PET
	| FieldNames.VEHICLE
	| FieldNames.TOW;

export enum ServiceConditions {
	MULTISTOREY_CAR_PARK = 'multistorey_car_park',
	NARROW_STREET = 'narrow_street',
	FRONT_DAMAGE = 'front_damage',
	NONE = 'none',
}
